<template>
  <div v-if="isLoading">
   <CanPayLoader/>
  </div>
  <div class="container" v-else>

    <div>
      <div class="row py-5 align-items-center">
        <div class="col-12 py-5"></div>
        <div class="col-12 text-center" v-if="required_upload_document != 0">
          <button
            type="button"
            class="btn-black btn-verify"
            @click="uploadDocument"
          >
            Upload Bank Statement
          </button>
        </div>
        <div class="col-12 text-center">
          <button
            type="button"
            class="btn-black btn-verify"
            @click="disabledAccounts"
          >
            Disabled Accounts
          </button>
        </div>
        <div class="col-12 text-center" v-if="currentUser.banking_solution_name == 'finicity'">
          <button
            type="button"
            class="btn-black btn-verify"
            @click="financialInstitutions"
          >
            Financial Institutions
          </button>
        </div>
        <div class="col-12 text-center" v-if="showPasskeyStatusLoader">
          <button
            type="button"
            class="btn-black btn-verify"
            disabled
          >
            <i class="fa fa-spinner fa-spin" style="margin-right: 5px;"></i>
            Checking Passkey...
          </button>
        </div>
        <div class="col-12 text-center" v-else-if="showRegisterPasskeyButton">
          <button
            type="button"
            class="btn-black btn-verify"
            @click="triggerRegisterPasskey"
            :disabled="isLoadingPasskey"
          >
             <i :class="isLoadingPasskey ? 'fa fa-spinner fa-spin' : biometricButtonIcon" style="margin-right: 5px;" v-if="isLoadingPasskey || biometricButtonIcon"></i>
             {{ isLoadingPasskey ? 'Processing...' : biometricButtonText }}
          </button>
          <!-- Fallback or Standard Register Passkey if logic above gets too complex, simplified: -->
          <!-- We want 'Register Passkey' (default) or 'Register Face ID' / 'Register Fingerprint' -->
        </div>
        <div class="col-12 text-center mt-2" v-if="showRemovePasskeysButton">
          <button
            type="button"
            class="btn-black btn-verify"
            style="background-color: #dc3545; border-color: #dc3545;"
            @click="triggerRemovePasskeys"
          >
            Remove All Passkeys
          </button>
        </div>
        <div class="col-12 py-4"></div>

        <div class="col-12 text-center">
          <label style="color: white; font-size: 1rem; margin-left: 0.5rem">
            Do you want to Deactivate your CanPay account?
          </label>
        </div>
        <div class="col-12 text-center mb-2">
          <button
            v-if="currentUser.can_deactive"
            type="button"
            class="btn-black btn-verify"
            @click="connectBankAccount"
          >
            Deactivate CanPay Account
          </button>
          <button
            v-else
            type="button"
            class="btn-black btn-verify btn-deactive"
          >
            Deactivate CanPay Account
          </button>
        </div>
        <div class="col-12 text-center">
          <button
            type="button"
            class="force-refresh-btn"
            @click="forceRefreshApp"
          >
            Refresh App
          </button>
        </div>
      </div>
    </div>

    <!----- MODAL FOR DEACTIVATE CONFIRMATION---->

    <div>
      <b-modal
        ref="confirm-modal"
        hide-footer
        v-b-modal.modal-center
        modal-backdrop
        hide-header
        id="confirm-modal"
        centered
      >
        <div class="color">
          <div class="col-12 text-center">
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              width="120"
              height="120"
              viewBox="0 0 100 125"
              style="enable-background: new 0 0 100 125"
              xml:space="preserve"
              fill="#e14343"
            >
              <path
                d="M96.2,47.5l-22-38c-0.4-0.6-1-1-1.7-1h-44c-0.7,0-1.4,0.4-1.7,1l-22,37.9c-0.4,0.6-0.4,1.4,0,2l22,38.1c0.4,0.6,1,1,1.7,1
	h44c0.7,0,1.4-0.4,1.7-1l22-38C96.6,48.9,96.6,48.1,96.2,47.5z M71.3,84.5H29.7L8.8,48.4l20.8-35.9h41.7l20.8,36L71.3,84.5z
	 M50.5,60.5c1.1,0,2-0.9,2-2v-30c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2v30C48.5,59.6,49.4,60.5,50.5,60.5z M48.4,66.4
	c-0.6,0.6-0.9,1.3-0.9,2.1c0,0.8,0.3,1.6,0.9,2.1s1.3,0.9,2.1,0.9c0.8,0,1.6-0.3,2.1-0.9c0.6-0.6,0.9-1.3,0.9-2.1
	c0-0.8-0.3-1.6-0.9-2.1C51.5,65.3,49.5,65.3,48.4,66.4z"
              />
            </svg>
          </div>
          <div class="purchaserpower-modal-text">
            <div class="d-block text-center">
              <label class="purchasepower-def-label">
                {{ deactivate_msg }}
              </label>
            </div>
            <div class="row">
              <div class="col-12 text-center">
                <button
                  @click="hideModal('confirm-modal')"
                  class="btn btn-danger btn-md center-block tip-btn"
                >
                  <label class="forgetpassword-ok-label">Cancel</label>
                </button>
                <button
                  @click="deactivate()"
                  class="btn btn-danger btn-md center-block tip-btn"
                  style="
                    background-color: #dc3545 !important;
                    border-color: #dc3545 !important;
                  "
                >
                  <label class="forgetpassword-ok-label">Deactivate</label>
                </button>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>

    <div>
      <b-modal
        ref="email-success-verification-code-modal"
        hide-footer
        v-b-modal.modal-center
        modal-backdrop
        hide-header
        no-close-on-backdrop
        id="email-success-verification-code-modal"
        centered
        title="BootstrapVue"
      >
        <div class="color">
          <div class="purchaserpower-modal-text">
            <div class="pin-success-top-spacing"></div>
            <div class="row" style="margin-bottom: 5px">
              <div class="col-4"></div>
              <div class="col-4 text-center">
                <img
                  class="onboarding-success-modal-image"
                  src="../../assets/images/success-image.png"
                />
              </div>
              <div class="col-4"></div>
            </div>
            <div class="d-block text-center">
              <label class="success-popup-style">Success!</label>
            </div>

            <div class="d-block text-center">
              <label class="onboarding-success-popup-style"
                >Your account deactivated successfully</label
              >
            </div>
            <div class="success-bottom-spacing"></div>
          </div>
        </div>
      </b-modal>
    </div>

    <!---- MODAL FOR  Error Modal  ---->
    <div>
      <b-modal
        ref="zero-pp-modal"
        hide-footer
        v-b-modal.modal-center
        modal-backdrop
        hide-header
        id="zero-pp-modal"
        centered
      >
        <div class="color">
          <div class="purchaserpower-modal-text">
            <div class="col-12 text-center">
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="120"
                height="120"
                viewBox="0 0 100 125"
                style="enable-background: new 0 0 100 125"
                xml:space="preserve"
                fill="#e14343"
              >
                <path
                  d="M96.2,47.5l-22-38c-0.4-0.6-1-1-1.7-1h-44c-0.7,0-1.4,0.4-1.7,1l-22,37.9c-0.4,0.6-0.4,1.4,0,2l22,38.1c0.4,0.6,1,1,1.7,1
	h44c0.7,0,1.4-0.4,1.7-1l22-38C96.6,48.9,96.6,48.1,96.2,47.5z M71.3,84.5H29.7L8.8,48.4l20.8-35.9h41.7l20.8,36L71.3,84.5z
	 M50.5,60.5c1.1,0,2-0.9,2-2v-30c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2v30C48.5,59.6,49.4,60.5,50.5,60.5z M48.4,66.4
	c-0.6,0.6-0.9,1.3-0.9,2.1c0,0.8,0.3,1.6,0.9,2.1s1.3,0.9,2.1,0.9c0.8,0,1.6-0.3,2.1-0.9c0.6-0.6,0.9-1.3,0.9-2.1
	c0-0.8-0.3-1.6-0.9-2.1C51.5,65.3,49.5,65.3,48.4,66.4z"
                />
              </svg>
            </div>
            <div class="d-block text-center">
              <label class="purchasepower-def-label">
                {{ pp_alert_message }}
              </label>
            </div>
            <br />
            <br />
            <div class="text-center">
              <button
                type="button"
                class="mx-auto col-10 offset-1 btn-black"
                style="height: 60px"
                @click="hideModal('zero-pp-modal')"
              >
                <label class="purchasepower-modal-ok-label">OK</label>
              </button>
            </div>
          </div>
        </div>
      </b-modal>
    </div>

    <!---- MODAL FOR Generic Success  ---->
    <div>
      <b-modal
        ref="generic-success-modal"
        hide-footer
        v-b-modal.modal-center
        modal-backdrop
        hide-header
        id="generic-success-modal"
        centered
      >
        <div class="color">
          <div class="purchaserpower-modal-text">
            <div class="pin-success-top-spacing"></div>
            <div class="row" style="margin-bottom: 5px">
              <div class="col-4"></div>
              <div class="col-4 text-center">
                <img
                  class="onboarding-success-modal-image"
                  src="../../assets/images/success-image.png"
                />
              </div>
              <div class="col-4"></div>
            </div>
            <div class="d-block text-center">
              <label class="success-popup-style">Success!</label>
            </div>
            <div class="d-block text-center">
              <label class="onboarding-success-popup-style">
                {{ success_message }}
              </label>
            </div>
            <br />
            <br />
            <div class="text-center">
              <button
                type="button"
                class="mx-auto col-10 offset-1 btn-black"
                style="height: 60px"
                @click="hideModal('generic-success-modal')"
              >
                <label class="purchasepower-modal-ok-label">OK</label>
              </button>
            </div>
            <div class="success-bottom-spacing"></div>
          </div>
        </div>
      </b-modal>
    </div>

    <!---- MODAL FOR Passkey PIN  ---->
    <div>
      <b-modal
        ref="passkey-pin-modal"
        hide-footer
        v-b-modal.modal-center
        modal-backdrop
        hide-header
        id="passkey-pin-modal"
        centered
      >
        <div class="color">
          <div class="passkey-modal-shell">
            <div class="passkey-modal-header">
              <div class="passkey-modal-badge">
                <span class="passkey-modal-badge-icon">
                  <i :class="passkeyModalIcon"></i>
                </span>
                <span class="passkey-modal-badge-text">
                  {{ passkeyMode === 'register' ? 'Passkey Security' : 'Passkey Management' }}
                </span>
              </div>
            </div>
            <div class="passkey-modal-content">
              <h4 class="passkey-modal-title">
                {{ passkeyMode === 'register' ? 'Enable Passkey Login' : 'Remove All Passkeys' }}
              </h4>
              <p class="passkey-modal-copy">
                {{ passkeyMode === 'register' ? 'Enter your Quick Access PIN to securely enable passkey sign-in on this device.' : 'Enter your Quick Access PIN to confirm removal of all saved passkeys.' }}
              </p>

              <div class="passkey-modal-field">
                <label class="passkey-modal-label">Quick Access PIN</label>
                <input
                  v-model="passkeyPin"
                  class="form-control passkey-modal-input"
                  placeholder="Enter 4-digit PIN"
                  type="password"
                  maxlength="4"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  autocomplete="off"
                  @input="handlePasskeyPinInput"
                />
                <p v-if="passkeyPinError" class="passkey-modal-error">
                  {{ passkeyPinError }}
                </p>
              </div>

              <div v-if="passkeyApiError" class="passkey-modal-api-error">
                {{ passkeyApiError }}
              </div>

              <div class="passkey-modal-actions">
                <button
                  type="button"
                  class="passkey-modal-btn passkey-modal-btn-secondary"
                  @click="closePasskeyPinModal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  class="passkey-modal-btn passkey-modal-btn-primary"
                  @click="confirmPasskeyAction"
                  :disabled="isRegisteringPasskey"
                >
                  {{ isRegisteringPasskey ? 'Processing...' : 'Confirm' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>

  </div>
</template>
<script>
import api from "../../api/login.js";
import accountAPI from "../../api/account.js";
import Loading from "vue-loading-overlay";
import CanPayLoader from "../CustomLoader/CanPayLoader.vue";
import { preProcessOptions, postProcessCredential } from "../../utils/webauthn";

export default {
  name: "Pay",
  components: {
    Loading,
    CanPayLoader
  },
  methods: {
    showModal(modal) {
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
    },
    connectBankAccount() {
      this.showModal("confirm-modal");
    },

    deactivate() {
      var self = this;
      self.hideModal("confirm-modal");
      self.isLoading = true;
      accountAPI
        .consumerdeactivate()
        .then((response) => {
          if (response.code == 200) {
            this.showSuccessCodeModal();
          } else {
            // alert(response.message);
            self.isLoading = false;
          }
          console.log("then")
        })
        .catch(function (error) {
          self.pp_alert_message = error.response.data.message;
          self.showModal("zero-pp-modal");
          self.isLoading = false;
          console.log("catch")
        });
    },
    showSuccessCodeModal() {
      var self = this;
      this.$refs["email-success-verification-code-modal"].show();
      setTimeout(function () {
        // self.hideSuccessCodeModal();
        self.logout();
      }, 4000);
    },
    handleToggleDrawer() {
      this.$refs.drawerLayout.toggle();
    },
    logout() {
      var self = this;
      api
        .logout()
        .then((response) => {
          if (response.code == 200) {
            localStorage.removeItem("consumer_token");
            localStorage.removeItem("nopurchasepower");
            localStorage.removeItem("purchasepower");
            localStorage.removeItem("consumer_login_response");
            localStorage.removeItem("enrollment");
            delete axios.defaults.headers.common["Authorization"];
            self.$router.push("/login").catch((err) => {});
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    uploadDocument() {
      var self = this;
      self.$router.push("/uploaddocument").catch((err) => {});
    },
    disabledAccounts(){
      var self = this;
      self.$router.push("/disablebanklisting").catch((err) => {});
    },
    financialInstitutions(){
      var self = this;
      self.$router.push("/financialinstitutions").catch((err) => {});
    },
    checkUserRequriedDocumentStatus() {
      accountAPI
        .checkUserRequriedDocumentStatus()
        .then((response) => {
          if (response.code == 200) {
            this.required_upload_document = response.data;
          }
        })
        .catch(function (error) {
          self.isLoading = false;
        });
    },
    getUserdetails(){
      var self = this;
      accountAPI
      .getUserdetails()
      .then(function (response) {
        if (response.code == 200) {
          localStorage.setItem(
            "consumer_login_response",
            JSON.stringify(response.data)
          );
          self.currentUser = response.data
          if (self.currentUser.bank_link_type == 1) {
            self.manual_bank_link = false;
          }
        }
      })
      .catch(function (error) {
      });
    },
    getPasskeyDeviceId() {
      const storageKey = "consumer_passkey_device_id";
      let deviceId = localStorage.getItem(storageKey);

      if (!deviceId) {
        if (window.crypto && typeof window.crypto.randomUUID === "function") {
          deviceId = window.crypto.randomUUID();
        } else {
          deviceId = "passkey-device-" + Date.now() + "-" + Math.random().toString(36).slice(2, 12);
        }
        localStorage.setItem(storageKey, deviceId);
      }

      return deviceId;
    },
    getPasskeyStatusStorageKey() {
      const consumerLoginResponse = localStorage.getItem("consumer_login_response");
      let userId = "guest";

      if (consumerLoginResponse) {
        try {
          const parsed = JSON.parse(consumerLoginResponse);
          userId = parsed && parsed.user_id ? parsed.user_id : userId;
        } catch (err) {
          console.error("Failed to parse consumer_login_response", err);
        }
      }

      return "consumer_passkey_status_" + userId;
    },
    setPasskeyStatus(hasAnyPasskeys, hasPasskeyForThisDevice, persistToStorage = true) {
      this.hasAnyPasskeys = !!hasAnyPasskeys;
      this.hasPasskeyForThisDevice = !!hasPasskeyForThisDevice;
      this.hasPasskeyStatusCache = true;

      if (persistToStorage) {
        localStorage.setItem(this.getPasskeyStatusStorageKey(), JSON.stringify({
          hasAnyPasskeys: this.hasAnyPasskeys,
          hasPasskeyForThisDevice: this.hasPasskeyForThisDevice
        }));
      }
    },
    loadPasskeyStatusFromStorage() {
      const rawStatus = localStorage.getItem(this.getPasskeyStatusStorageKey());

      if (!rawStatus) {
        this.hasPasskeyStatusCache = false;
        return false;
      }

      try {
        const parsedStatus = JSON.parse(rawStatus);
        this.hasAnyPasskeys = !!parsedStatus.hasAnyPasskeys;
        this.hasPasskeyForThisDevice = !!parsedStatus.hasPasskeyForThisDevice;
        this.hasPasskeyStatusCache = true;
        return true;
      } catch (err) {
        console.error("Failed to parse cached passkey status", err);
        localStorage.removeItem(this.getPasskeyStatusStorageKey());
        this.hasPasskeyStatusCache = false;
        return false;
      }
    },
    refreshPasskeyStatus() {
      if (!window.PublicKeyCredential || !this.isWebAuthnAvailable) {
        this.setPasskeyStatus(false, false);
        this.isCheckingPasskeyStatus = false;
        return Promise.resolve();
      }

      this.isCheckingPasskeyStatus = true;

      return api.webauthnStatus({ device_id: this.getPasskeyDeviceId() })
        .then((response) => {
          this.setPasskeyStatus(
            response.has_any_passkeys,
            response.has_passkey_for_this_device
          );
        })
        .catch((err) => {
          console.error("Failed to fetch passkey status", err);
          if (!this.hasPasskeyStatusCache) {
            this.setPasskeyStatus(false, false);
          }
        })
        .finally(() => {
          this.isCheckingPasskeyStatus = false;
        });
    },
    detectBiometricDisplay() {
        const ua = navigator.userAgent.toLowerCase();
        // Heuristic detection
        if (/iphone|ipad|ipod/.test(ua)) {
             this.biometricButtonText = "Register Face ID";
             this.biometricButtonIcon = "fa fa-id-card"; 
        } else if (/android/.test(ua)) {
             this.biometricButtonText = "Register Fingerprint";
             this.biometricButtonIcon = "fa fa-hand-o-up"; 
        } else {
             this.biometricButtonText = "Register Passkey";
             this.biometricButtonIcon = "fa fa-key"; 
        }
    },
    
    forceRefreshApp() {
      location.reload(true);
    },
    triggerRegisterPasskey() {
        if (this.isLoadingPasskey) return;
        this.passkeyMode = 'register';
        this.passkeyPin = '';
        this.passkeyPinError = '';
        this.passkeyApiError = '';
        this.showModal('passkey-pin-modal');
    },

    clearPasskeyPinError() {
        this.passkeyPinError = '';
    },
    clearPasskeyApiError() {
        this.passkeyApiError = '';
    },
    closePasskeyPinModal() {
        this.passkeyPin = '';
        this.passkeyPinError = '';
        this.passkeyApiError = '';
        this.hideModal('passkey-pin-modal');
    },

    handlePasskeyPinInput(event) {
        this.passkeyPin = event.target.value.replace(/\D/g, '').slice(0, 4);
        this.clearPasskeyPinError();
        this.clearPasskeyApiError();
    },

    triggerRemovePasskeys() {
        this.passkeyMode = 'remove';
        this.passkeyPin = '';
        this.passkeyPinError = '';
        this.passkeyApiError = '';
        this.showModal('passkey-pin-modal');
    },

    confirmPasskeyAction() {
        if (this.isRegisteringPasskey) return; 

        if (!/^\d{4}$/.test(this.passkeyPin)) {
             this.passkeyPinError = "Please enter a valid 4-digit PIN.";
             return;
        }
        this.passkeyPinError = '';
        this.passkeyApiError = '';
        
        this.isRegisteringPasskey = true;
        
        // Note: We are NOT hiding the modal immediately to show the "Processing..." state on the button
        // inside the modal itself, which provides better feedback than closing and showing a global loader.
        // However, the original code used a global loader. Let's stick to the modal concept for the button, 
        // but we can also keep the global loader if desired.

        if (this.passkeyMode === 'register') {
            this.registerPasskeyWithPin();
        } else {
            this.removePasskeysWithPin();
        }
    },

    registerPasskeyWithPin() {
        let self = this;
        self.isLoadingPasskey = true; 

        api.webauthnRegisterOptions()
            .then(options => {
                options = preProcessOptions(options);
                // Enforce platform authenticator with strict user verification (FaceID/System Password)
                if (!options.authenticatorSelection) options.authenticatorSelection = {};
                options.authenticatorSelection.authenticatorAttachment = 'platform';
                options.authenticatorSelection.userVerification = 'required';
                options.authenticatorSelection.residentKey = 'required';
                options.authenticatorSelection.authenticatorAttachment = 'platform';
                options.authenticatorSelection.userVerification = 'required';
                options.authenticatorSelection.residentKey = 'preferred';
                return navigator.credentials.create({ publicKey: options });
            })
            .then(credential => {
                 const credData = postProcessCredential(credential);
                 credData.pin = self.passkeyPin;
                 credData.device_id = self.getPasskeyDeviceId();
                 return api.webauthnRegister(credData); // Actually registers
            })
            .then(() => {
                return self.refreshPasskeyStatus();
            })
            .then(() => {
                self.hideModal('passkey-pin-modal'); // Hide modal only on success
                self.isRegisteringPasskey = false;
                self.isLoadingPasskey = false;
                self.success_message = "Passkey registered successfully!";
                self.$nextTick(() => {
                    self.showModal("generic-success-modal");
                });
            })
            .catch(err => {
                self.isRegisteringPasskey = false;
                self.isLoadingPasskey = false;
                console.error(err);
                if (err.name === 'NotAllowedError') {
                    self.passkeyApiError = "Failed to enable Passkey.";
                    return;
                }
                let msg = err.message || err;
                if (err.response && err.response.data && err.response.data.error) {
                    msg = err.response.data.error;
                }
                self.passkeyApiError = msg;
            });
    },

    removePasskeysWithPin() {
        let self = this;
        // self.isLoading = true;
        
        api.webauthnRemove({
            pin: self.passkeyPin,
            device_id: self.getPasskeyDeviceId(),
        })
            .then(() => {
                return self.refreshPasskeyStatus();
            })
            .then(() => {
                self.hideModal('passkey-pin-modal');
                self.isRegisteringPasskey = false;
                self.success_message = "All passkeys removed successfully.";
                self.$nextTick(() => {
                    self.showModal("generic-success-modal");
                });
            })
            .catch(err => {
                self.isRegisteringPasskey = false;
                console.error(err);
                let msg = err.message || err;
                if (err.response && err.response.data && err.response.data.error) {
                    msg = err.response.data.error;
                }
                self.passkeyApiError = msg;
            });
    },

  },
  data() {
    let self = this;
    return {
      isLoading: false,
      fullPage: true,
      deactivate_msg:
        "Are you sure you want to Deactivate your CanPay Account? You will no longer be able to access the CanPay App or your CanPay account. You will only be able to reactivate your CanPay account in the future by contacting CanPay's customer service.",
      pp_alert_message: "",
      success_message: "",
      required_upload_document: 0,
      currentUser: {},
      passkeyPin: '',
      passkeyPinError: '',
      passkeyApiError: '',
      passkeyMode: 'register',
      isWebAuthnAvailable: false,
      hasAnyPasskeys: false,
      hasPasskeyForThisDevice: false,
      hasPasskeyStatusCache: false,
      isCheckingPasskeyStatus: true,
      biometricButtonText: "Register Passkey",
      biometricButtonIcon: "fa fa-key",
      isLoadingPasskey: false,
      isRegisteringPasskey: false
    };
  },
  computed: {
    passkeyModalIcon() {
      if (this.passkeyMode === 'remove') {
        return 'fa fa-trash';
      }

      return this.biometricButtonIcon || 'fa fa-key';
    },
    showPasskeyStatusLoader() {
      return this.isWebAuthnAvailable && this.isCheckingPasskeyStatus && !this.hasPasskeyStatusCache;
    },
    showRegisterPasskeyButton() {
      return this.isWebAuthnAvailable && (!this.isCheckingPasskeyStatus || this.hasPasskeyStatusCache) && !this.hasPasskeyForThisDevice;
    },
    showRemovePasskeysButton() {
      return this.isWebAuthnAvailable && (!this.isCheckingPasskeyStatus || this.hasPasskeyStatusCache) && this.hasAnyPasskeys;
    }
  },
  created() {
    this.$root.$emit("loginapp", [""]);
    this.checkUserRequriedDocumentStatus();
    // Check for WebAuthn platform authenticator availability
    if (window.PublicKeyCredential) {
        window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable()
        .then((available) => {
            this.isWebAuthnAvailable = available;
            if (available) {
                this.detectBiometricDisplay();
                this.loadPasskeyStatusFromStorage();
                this.refreshPasskeyStatus();
            } else {
                this.setPasskeyStatus(false, false);
                this.isCheckingPasskeyStatus = false;
            }
        })
        .catch((err) => {
            console.error("Error checking WebAuthn availability", err);
            this.isWebAuthnAvailable = false; 
            this.setPasskeyStatus(false, false);
            this.isCheckingPasskeyStatus = false;
        });
    } else {
         this.isWebAuthnAvailable = false;
         this.setPasskeyStatus(false, false);
         this.isCheckingPasskeyStatus = false;
    }
  },
  mounted() {
    var element = document.getElementsByClassName("content-wrap");
    var elementTwo = document.getElementsByClassName("drawer-black-content");
    elementTwo[0].style.setProperty("background-color", "#149240");
    console.log(elementTwo);
    if (element[0]) {
      element[0].style.setProperty("background-color", "#149240");
      element[0].style.height = "114vh";
      if(window.innerWidth>1200){
        element[0].style.height = "121vh";
      }
    }
    this.$root.$emit("loginapp", [""]);
    this.$root.$emit("changeWhiteBackground", [false, true, "common"]);
    this.getUserdetails();
  },
};
</script>

<style lang="scss">
#confirm-modal___BV_modal_body_,
#zero-pp-modal___BV_modal_body_,
#email-success-verification-code-modal___BV_modal_body_,
#generic-success-modal___BV_modal_body_,
#passkey-pin-modal___BV_modal_body_,
#generic-error-modal___BV_modal_body_ {
  background-color: #ffffff;
  border-radius: 12px;
  margin: 10px;
}
.btn-deactive{
  background: #282828!important;
  cursor: no-drop!important;
}
.force-refresh-btn{
  border: 0;
  width: 100%;
  padding: 15px 15px;
  background: #000;
  color: #fff;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
}
.passkey-modal-shell {
  padding: 20px 18px 14px;
}
.passkey-modal-header {
  display: flex;
  justify-content: center;
  margin-bottom: 18px;
}
.passkey-modal-badge {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 999px;
  background: linear-gradient(180deg, #f4fbf6 0%, #e9f7ee 100%);
  border: 1px solid rgba(20, 146, 64, 0.18);
  box-shadow: 0 8px 20px rgba(20, 146, 64, 0.08);
}
.passkey-modal-badge-icon {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #149240;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}
.passkey-modal-badge-text {
  color: #0f6d34;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.02em;
}
.passkey-modal-content {
  text-align: center;
}
.passkey-modal-title {
  margin: 0 0 10px;
  color: #111111;
  font-size: 31px;
  font-weight: 800;
  line-height: 1.1;
}
.passkey-modal-copy {
  margin: 0 auto 22px;
  max-width: 310px;
  color: #5f6673;
  font-size: 16px;
  line-height: 1.5;
}
.passkey-modal-field {
  text-align: left;
  margin-bottom: 22px;
}
.passkey-modal-label {
  display: block;
  margin-bottom: 9px;
  color: #1a1a1a;
  font-size: 14px;
  font-weight: 700;
}
.passkey-modal-input {
  height: 54px;
  border: 1px solid #d7dee5;
  border-radius: 14px;
  padding: 0 18px;
  font-size: 16px;
  box-shadow: none;
  background: #fbfcfd;
}
.passkey-modal-input:focus {
  border-color: #149240;
  box-shadow: 0 0 0 3px rgba(20, 146, 64, 0.12);
  background: #ffffff;
}
.passkey-modal-error {
  margin: 8px 0 0;
  color: #dc3545;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
}
.passkey-modal-api-error {
  margin: 0 0 18px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #fff5f5;
  border: 1px solid #f3c2c7;
  color: #dc3545;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
  text-align: left;
}
.passkey-modal-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.passkey-modal-btn {
  height: 52px;
  border-radius: 14px;
  border: 0;
  font-size: 16px;
  font-weight: 700;
  transition: all 0.2s ease;
}
.passkey-modal-btn:disabled {
  opacity: 0.7;
}
.passkey-modal-btn-secondary {
  background: #f1f3f5;
  color: #1f2937;
}
.passkey-modal-btn-primary {
  background: #111111;
  color: #ffffff;
}
.passkey-modal-btn-primary:hover,
.passkey-modal-btn-primary:focus {
  background: #000000;
}
.passkey-modal-btn-secondary:hover,
.passkey-modal-btn-secondary:focus {
  background: #e6eaee;
}
@media (max-width: 480px) {
  .passkey-modal-shell {
    padding: 16px 10px 8px;
  }
  .passkey-modal-title {
    font-size: 25px;
  }
  .passkey-modal-copy {
    font-size: 15px;
    margin-bottom: 18px;
  }
  .passkey-modal-actions {
    grid-template-columns: 1fr;
  }
}
</style>

